module.exports = __webpack_public_path__ + "../resources/img/bg_pv3_03.a5770234.png";